import { Component } from 'react'
import * as dotObject from 'dot-object'
import { PermissionResult } from '../../../helpers/permission-checker.helper'

type ActionRefsType = {
  save: any
}

export type FormComponentProps = {
  permissions?: PermissionResult
}
export default class FormComponent<T> extends Component<T> {
  actionRefs = {
    save: null
  } as ActionRefsType

  formRef: any

  componentDidUpdate(prevProps: any, prevState: any) {
    this.validateAccessPermissions()
  }

  validateAccessPermissions = () => {
    const { permissions, history }: any = this.props

    if (permissions) {
      const pathname = (history?.pathname || history?.location?.pathname) as string | null
      if (pathname && history.replace) {
        const lastParamIndex = pathname.lastIndexOf('/')

        if (lastParamIndex >= 0) {
          const lastParam = pathname.slice(lastParamIndex + 1, pathname.length)
          if (lastParam === 'add' && !permissions.create) {
            history.replace('/organization/shelter')
          }
        }
      }

      if (this.actionRefs.save) {
        this.actionRefs.save.style.display = !permissions.save ? 'none' : ''
      }
    }
  }

  parseContextErrors = (contextError: any = null) => {
    if (!contextError && (this.props as any).error)  {
      contextError = (this.props as any).error
    }

    if (contextError && this.formRef?.__INTERNAL__?.name) {
      const formName = this.formRef.__INTERNAL__.name
      let errors: Array<any> = []

      Object.keys(contextError).forEach(k => {
        let message = contextError[k]
        const field = k.split('.').filter(name => name !== formName)
        const instance = this.formRef.getFieldInstance(field)
        
        // Parse to array of strings if the message is string
        if (typeof message === 'string') {
          message = [message]
        }
        
        if (instance && message) {
          message = message.map(msg => msg.replace(`The ${k.replaceAll('_', ' ')}`, ''))

          errors.push({
            name: field,
            errors: message
          })
        }
      })

      if (errors.length > 0) {
        this.formRef.setFields(errors)
      }
    }
  }

  private getContinuous = (objName: string, state: any, name: string, values: any) => {
    if (state[objName] instanceof Array) {
      const index = state[objName].findIndex(v => v[name] === values[name])
      // Update existing in array
      if (index >= 0) {
        state[objName][index] = values
        return state[objName]
      }

      return [
        ...state[objName],
        ...values
      ]
    }

    return {
      ...state[objName],
      ...values
    }
  }

  protected onFieldsChange = (inputEvent: any, objName?: string) => {
    const name: string = inputEvent.target.name || ''
    const value = inputEvent.target.value
    if (name.length === 0) return null

    if (objName && objName.length > 0) {
      if (name.includes('.')) {
        this.setState((state: any) => ({
          ...state,
          [objName]: this.getContinuous(objName, state, name, dotObject.str(name, value, state[objName]))
        }))
      } else {
        this.setState((state: any) => ({
          ...state,
          [objName]: this.getContinuous(objName, state, name, { [name]: value })
        }))
      }
    } else {
      if (name.includes('.')) {
        this.setState((state: any) => ({
          ...state,
          ...dotObject.str(name, value, state)
        }))
      } else {
        this.setState((state: any) => ({
          ...state,
          [name]: value
        }))
      }
    }
  }

  protected getFieldValue = (name: string, objName?: string) => {
    if (name.length === 0) return null

    if (objName && objName.length > 0) {
      if (name.includes('.')) {
        return dotObject.pick(name, this.state[objName])
      } else {
        return this.state[objName][name]
      }
    } else {
      if (name.includes('.')) {
        return dotObject.pick(name, this.state)
      } else {
        return this.state[name]
      }
    }
  }
}
